import { z } from 'zod'

export const PaginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(500).default(20),
  sort_by: z.string().optional(),
  sort_order: z.enum(['asc', 'desc']).default('desc'),
})

export const DateRangeSchema = z.object({
  date_from: z.string().date().optional(),
  date_to: z.string().date().optional(),
})

export const UUIDParamSchema = z.object({
  id: z.string().uuid('Geçersiz kimlik formatı.'),
})

export type PaginationInput = z.infer<typeof PaginationSchema>
export type DateRangeInput = z.infer<typeof DateRangeSchema>
export type UUIDParamInput = z.infer<typeof UUIDParamSchema>
